import { parsePhoneNumberWithError } from "libphonenumber-js"
import { z } from "zod"

export function emailValidator() {
    return z
        .string({ required_error: "Email required" })
        .email("Invalid email")
        .transform(value => value.toLowerCase())
        .refine(value => value.length > 0, { message: "Email cannot be blank" })
}

export function phoneValidator() {
    return z
        .string({ required_error: "Phone required" })
        .transform((value, ctx) => {
            if (value.length > 1) {
                const phone = parsePhoneNumberWithError(value, {
                    defaultCountry: "US"
                })
        
                if (phone.isValid()) {
                    return phone.number
                }
            } else {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: "Please enter a valid phone number"
                })
                return z.NEVER
            }
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: "Invalid phone"
            }) 
            return z.NEVER
        })
}